import { Spinner, Box, Flex, Text, Checkbox, calc } from "@chakra-ui/react";
import { ChatLoader } from "./chat/chatLoader";
import { StyledChatContainer } from "./style";
import { useEffect, useMemo, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { CustonButtom } from "../common/button/customButton";
import { DawnloadIcon } from "@root/assets/icons/DawnloadIcon";
import { useTranslation } from "react-i18next";
import ChatBody from "./chat/roles";
import { useDispatch, useSelector } from "react-redux";
import { exportChat } from "@root/store/thunks/chatThunks";
import {
  downlodFile,
  getUserGMTOffset,
} from "@root/utils/download-file-helper";
import { DawnloadWhiteIcon } from "@root/assets/icons/DawonloadWhiteIcon";
import { DownArrow } from "@root/assets/icons/downArrow";
import { useMainChatContext } from "@root/context/kps-chat-context";
import { getSelectedModel } from "@root/store/selectors/entities/thread";
import ChatHead from "@root/pages/dashboard/components/ChatHead";
import ChatMode from "@root/pages/dashboard/components/chatMode";
import { useScrollToBottomButton } from "@root/hooks/useScrollToBottomButton";

const ChatContainer = ({
  data,
  loading,
  chatloading,
  uid = null,
  editSubmitHandler,
  model,
  threadId,
}: any) => {
  // Infinite Scroll
  const { t } = useTranslation("common");
  const [scrollPosition, setScrollPosition] = useState(0);
  const [scrollheight, setScrollheight] = useState("auto");
  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const scrollableDivRef = useRef<HTMLDivElement | null>(null);
  const scrollRef = useRef<HTMLDivElement>(null);
  const scrollRef2 = useRef<any>(null);
  const [isHovered, setIsHovered] = useState(false);
  const [allSelected, setAllSelected] = useState<any>(false);
  const [selectedChatIds, setSelectedChatIds] = useState<number[]>([]);

  // Fetch More data
  const [items, setItems] = useState(Array.from({ length: 20 }));
  const [hasMore, setHasMore] = useState(true);

  const { isWritingFirstPatch, isPanelVisible, updateChatModeValue, chatMode } =
    useMainChatContext();
  const scrollBottomRef = useRef<HTMLDivElement>(null);
  const { showScrollButton, scrollToBottom } =
    useScrollToBottomButton(scrollBottomRef);

  // ThreadTitle
  const [titles, setTitles] = useState<Map<number, string>>(new Map());
  const [checkedItems, setCheckedItems] = useState<boolean[]>([]);

  useEffect(() => {
    setCheckedItems(Array(data?.length).fill(false));
  }, [data]);

  const allChecked = checkedItems?.length > 0 && checkedItems?.every(Boolean);

  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setAllSelected(isChecked);

    if (isChecked) {
      const allIds = data.map((item: any) => item?.meta?.c?.id);
      setSelectedChatIds(allIds);
    } else {
      setSelectedChatIds([]);
    }

    setCheckedItems(Array(data?.length).fill(isChecked));
  };
  const toggleId = (id: number) => {
    setSelectedChatIds((prevIds) =>
      prevIds.includes(id)
        ? prevIds.filter((item) => item !== id)
        : [...prevIds, id]
    );
  };

  const handleChildCheckbox =
    (index: number, chat: any) => (e: React.ChangeEvent<HTMLInputElement>) => {
      setAllSelected(false);
      toggleId(chat?.meta?.c?.id);
      const updatedCheckedItems = [...checkedItems];
      updatedCheckedItems[index] = e.target.checked;
      setCheckedItems(updatedCheckedItems);
    };

  useEffect(() => {
    const threadTitles = new Map<number, string>();

    data.forEach((chat: any) => {
      const threadId = chat.threadId;
      const question = chat.meta?.question || chat.input;

      if (!threadTitles.has(threadId) && question) {
        threadTitles.set(threadId, question);
      }
    });

    setTitles(threadTitles);
  }, [data]);

  useEffect(() => {
    if (scrollRef2?.current && scrollRef?.current) {
      if (scrollRef?.current?.offsetHeight > scrollRef2?.current.offsetHeight) {
        setScrollheight("100%");
      } else {
        setScrollheight("auto");
      }
    }
  }, [data]);

  useMemo(() => {
    if (scrollableDivRef.current) {
      scrollableDivRef.current.scrollTop =
        scrollableDivRef.current.scrollHeight;
    }
  }, []);

  const onScrollHandler = () => {
    if (scrollableDivRef.current) {
      setScrollPosition(scrollableDivRef.current?.scrollTop);
    }
  };

  const fetchMoreData = () => {
    if (items?.length >= 200) {
      // stop at 200 items
      setHasMore(false);
      return;
    }

    // Simulate API call with a delay
    setTimeout(() => {
      setItems((prevItems) => prevItems.concat(Array.from({ length: 20 })));
    }, 1500);
  };

  const threadTitle = Array.from(titles.entries())[0];
  const modelOption = useSelector(getSelectedModel);
  const dispatch = useDispatch();

  const handleExport = () => {
    setIsDownloading(true);
    dispatch(
      exportChat({
        apiParams: {
          threadId: threadId,
          chatIds: allSelected ? [] : selectedChatIds,
          gmtOffset: getUserGMTOffset(),
        },
        onSuccess: async (res: any) => {
          const pdfUrl = res?.data?.signedUrl;
          let fileTitle = `QuestionsAndAnswers.pdf`;
          downlodFile(
            pdfUrl,
            fileTitle,
            t("chat.chatFail"),
            dispatch,
            setIsDownloading
          );
        },
        onError: () => {
          setIsDownloading(false);
        },
      })
    );
  };

  return (
    <Box height={"100vh"} overflow={"hidden"} className="chatContainer">
      {/* {threadTitle && (
        <Box top={"10px"} key={threadTitle[0]} position={"relative"}>
          <Text
            fontSize="20px"
            fontWeight="500"
            textOverflow="ellipsis"
            px="20px"
            py="5px"
            width="85%"
            whiteSpace="nowrap"
            overflow="hidden"
          >
            {threadTitle[1]}
          </Text>
          <Box
            marginLeft={"15px"}
            position={"absolute"}
            top={"60px"}
            left={"8px"}
            border={"1px solid"}
            borderColor={"#0ECCF2"}
            borderRadius={"4px"}
            backgroundColor={"white"}
            padding={"6px 8px"}
            fontSize={"14px"}
            color={"#337CC1"}
          >
            {modelOption?.label}
          </Box>
        </Box>
      )} */}

      {/* <CustonButtom
        border={"1px solid"}
        borderColor={"gray.300"}
        bg={selectedChatIds?.length > 0 ? "purple.500" : "black.400"}
        textColor={selectedChatIds?.length > 0 ? "white" : "gray.300"}
        position={"fixed"}
        top={8}
        gap={"12px"}
        right={8}
        isLoading={isDownloading}
        isDisabled={selectedChatIds?.length === 0 || isDownloading}
        startadornicon={
          selectedChatIds?.length > 0 ? <DawnloadWhiteIcon /> : <DawnloadIcon />
        }
        text={t("download.dawonloadAnswer")}
        onClick={handleExport}
        maxH="37px"
        borderRadius="8px"
        fontSize="12px"
      /> */}
      <Box
        justifyContent={"center"}
        height="calc(100vh - 40px)"
        overflow="hidden"
        px={"30px"}
        transition="padding 0.3s ease"
      >
        <Box
          position="relative"
          overflow={"hidden"}
          // width={"856px"}
          height={"100%"}
          marginLeft={"30px"}
        >
          <div ref={scrollRef2} style={{ height: "100%", overflow: "hiden" }}>
            <div
              id="scrollableDiv"
              style={{
                height: "100%",
                overflow: "auto",
                display: "flex",
                flexDirection: "column-reverse",
                position: "relative",
              }}
              onScroll={onScrollHandler}
              ref={scrollBottomRef}
            >
              <InfiniteScroll
                dataLength={data?.length}
                next={fetchMoreData}
                style={{ display: "flex", flexDirection: "column-reverse" }}
                inverse={true}
                hasMore={hasMore}
                loader={<></>}
                scrollableTarget="scrollableDiv"
              >
                {/* <Checkbox
                  isChecked={allChecked}
                  onChange={handleSelectAll}
                  position="fixed"
                  top={20}
                  right={14}
                  sx={{
                    borderColor: "#C5C7D0",
                  }}
                >
                  {t("chat.selectAll")}
                </Checkbox> */}
                {/* Scrollable chat area */}
                <StyledChatContainer overflow={"auto"}>
                  {/* {chatloading && <Spinner margin={"auto"} />} */}
                  {!chatloading &&
                    data?.map((chat: any, i: number) => {
                      return (
                        <Flex
                          key={i}
                          justifyContent={"flex-end"}
                          alignItems="center"
                          onMouseEnter={() => setIsHovered(true)}
                          onMouseLeave={() => setIsHovered(false)}
                        >
                          <ChatBody
                            loading={loading}
                            editSubmitHandler={editSubmitHandler}
                            uid={uid}
                            mode={chatMode}
                            chat={chat}
                          />
                          <Flex mt={"-35px"} marginLeft={"8px"}>
                            {/* {chat.role === "user" &&
                              (isHovered || checkedItems[i]) && (
                                <Checkbox
                                  sx={{
                                    borderColor: "#C5C7D0",
                                  }}
                                  isChecked={checkedItems[i]}
                                  onChange={handleChildCheckbox(i, chat)}
                                />
                              )} */}
                          </Flex>
                        </Flex>
                      );
                    })}
                </StyledChatContainer>

                {/* Scroll to bottom button */}
                {/* {showScrollButton && (
                  <Box
                    position="absolute"
                    bottom="20px"
                    right="20px"
                    zIndex={10}
                    bg="white"
                    borderRadius="50%"
                    p={2}
                    boxShadow="0 4px 12px rgba(0, 0, 0, 0.15)"
                    cursor="pointer"
                    onClick={scrollToBottom}
                    _hover={{
                      bg: "gray.50",
                      transform: "scale(1.05)",
                    }}
                    transition="all 0.2s ease"
                  >
                    <DownArrow />
                  </Box>
                )} */}
              </InfiniteScroll>
            </div>
          </div>

          {/* <Flex justifyContent={"center"} zIndex={9}>
            <Box marginLeft={"150px"} marginTop={"10px"} bottom={"-60px"}>
              {isWritingFirstPatch && <ChatLoader />}
            </Box>
          </Flex> */}
        </Box>
      </Box>
    </Box>
  );
};

export { ChatContainer };
